module.exports = __webpack_public_path__ + "static/img/03.bf908df6.png";